/**
 * Item DocType-specific translations.
 * Key: `Item:${fieldname}`
 * Value: { en: string, th: string }
 */
export const itemTranslations: Record<string, { en: string; th: string }> = {
  "Item:item_code": { en: "Item Code", th: "รหัสสินค้า" },
  "Item:item_name": { en: "Item Name", th: "ชื่อสินค้า" },
  "Item:item_group": { en: "Item Group", th: "กลุ่มสินค้า" },
  "Item:stock_uom": { en: "Stock UOM", th: "หน่วยสต็อก" },
  "Item:middleware_partner_key": { en: "Partner", th: "พาร์ทเนอร์" },
  "Item:middleware_partner_key_locked": { en: "Lock Partner Key", th: "ล็อคคีย์พาร์ทเนอร์" },
  "Item:standard_rate": { en: "Standard Rate", th: "ราคามาตรฐาน" },
  
  // Inventory fields
  "Item:is_stock_item": { en: "Is Stock Item", th: "เป็นสินค้าสต็อก" },
  "Item:has_batch_no": { en: "Has Batch No", th: "มีหมายเลขล็อต" },
  "Item:create_new_batch": { en: "Automatically Create New Batch", th: "สร้างล็อตใหม่อัตโนมัติ" },
  "Item:batch_number_series": { en: "Batch Number Series", th: "ชุดหมายเลขล็อต" },
  "Item:has_expiry_date": { en: "Has Expiry Date", th: "มีวันหมดอายุ" },
  "Item:retain_sample": { en: "Retain Sample", th: "เก็บตัวอย่าง" },
  "Item:max_sample_quantity": { en: "Max Sample Quantity", th: "จำนวนตัวอย่างสูงสุด" },
  "Item:max_sample_qty": { en: "Max Sample Quantity", th: "จำนวนตัวอย่างสูงสุด" },
  "Item:has_serial_no": { en: "Has Serial No", th: "มีหมายเลขซีเรียล" },
  "Item:include_item_in_manufacturing": { en: "Include Item in Manufacturing", th: "รวมสินค้าในการผลิต" },
  "Item:is_item_from_hub": { en: "Is Item From Hub", th: "เป็นสินค้าจาก Hub" },
  "Item:hub": { en: "Hub", th: "Hub" },
  "Item:reorder_level": { en: "Reorder Level", th: "ระดับการสั่งซื้อใหม่" },
  "Item:reorder_levels": { en: "Reorder Levels", th: "ระดับการสั่งซื้อใหม่" },
  "Item:reorder_level_based_on_warehouse": { en: "Reorder level based on Warehouse", th: "ระดับการสั่งซื้อใหม่ตามคลังสินค้า" },
  "Item:item_reorder": { en: "Item Reorder", th: "การสั่งซื้อสินค้าใหม่" },
  "Item:reorder_qty": { en: "Reorder Qty", th: "จำนวนการสั่งซื้อใหม่" },
  "Item:min_order_qty": { en: "Min Order Qty", th: "จำนวนสั่งซื้อขั้นต่ำ" },
  "Item:max_order_qty": { en: "Max Order Qty", th: "จำนวนสั่งซื้อสูงสุด" },
  "Item:safety_stock": { en: "Safety Stock", th: "สต็อกความปลอดภัย" },
  "Item:lead_time_days": { en: "Lead Time Days", th: "ระยะเวลารอคอย (วัน)" },
  "Item:default_warehouse": { en: "Default Warehouse", th: "คลังสินค้าเริ่มต้น" },
  "Item:default_material_request_type": { en: "Default Material Request Type", th: "ประเภทคำขอวัสดุเริ่มต้น" },
  "Item:valuation_rate": { en: "Valuation Rate", th: "อัตราการประเมินมูลค่า" },
  "Item:last_purchase_rate": { en: "Last Purchase Rate", th: "ราคาซื้อล่าสุด" },
  "Item:weight_per_unit": { en: "Weight Per Unit", th: "น้ำหนักต่อหน่วย" },
  "Item:weight_uom": { en: "Weight UOM", th: "หน่วยน้ำหนัก" },
  "Item:shelf_life_in_days": { en: "Shelf Life In Days", th: "อายุการเก็บรักษา (วัน)" },
  "Item:end_of_life": { en: "End of Life", th: "สิ้นสุดอายุการใช้งาน" },
  
  // Valuation and pricing
  "Item:valuation_method": { en: "Valuation Method", th: "วิธีการประเมินมูลค่า" },
  
  // Warranty and quality
  "Item:warranty_period": { en: "Warranty Period", th: "ระยะเวลาการรับประกัน" },
  "Item:has_warranty": { en: "Has Warranty", th: "มีการรับประกัน" },
  
  // Stock control
  "Item:allow_negative_stock": { en: "Allow Negative Stock", th: "อนุญาตสต็อกติดลบ" },
  "Item:negative_stock_allowed": { en: "Negative Stock Allowed", th: "อนุญาตสต็อกติดลบ" },
  
  // Barcodes
  "Item:barcode": { en: "Barcode", th: "บาร์โค้ด" },
  "Item:barcodes": { en: "Barcodes", th: "บาร์โค้ด" },
  
  // Additional inventory fields
  "Item:item_defaults": { en: "Item Defaults", th: "ค่าเริ่มต้นสินค้า" },
  "Item:stock_keeping_unit": { en: "Stock Keeping Unit", th: "หน่วยเก็บสต็อก" },
  "Item:is_fixed_asset": { en: "Is Fixed Asset", th: "เป็นสินทรัพย์ถาวร" },
  "Item:auto_create_assets": { en: "Auto Create Assets", th: "สร้างสินทรัพย์อัตโนมัติ" },
  "Item:asset_category": { en: "Asset Category", th: "หมวดหมู่สินทรัพย์" },
  "Item:asset_naming_series": { en: "Asset Naming Series", th: "ชุดชื่อสินทรัพย์" },
  
  // Manufacturing
  "Item:is_purchase_item": { en: "Is Purchase Item", th: "เป็นสินค้าซื้อ" },
  "Item:is_sales_item": { en: "Is Sales Item", th: "เป็นสินค้าขาย" },
  "Item:is_sub_contracted_item": { en: "Is Sub Contracted Item", th: "เป็นสินค้าจ้างผลิต" },
  "Item:is_customer_provided_item": { en: "Is Customer Provided Item", th: "เป็นสินค้าลูกค้านำมา" },
  
  // Quality and inspection
  "Item:inspection_required": { en: "Inspection Required", th: "ต้องตรวจสอบ" },
  "Item:inspection_required_before_purchase": { en: "Inspection Required before Purchase", th: "ต้องตรวจสอบก่อนซื้อ" },
  "Item:inspection_required_before_delivery": { en: "Inspection Required before Delivery", th: "ต้องตรวจสอบก่อนส่งมอบ" },
  "Item:quality_inspection_template": { en: "Quality Inspection Template", th: "เทมเพลตตรวจสอบคุณภาพ" },
  
  // Accounting - Deferred
  "Item:enable_deferred_expense": { en: "Enable Deferred Expense", th: "เปิดใช้งานค่าใช้จ่ายรอตัดบัญชี" },
  "Item:enable_deferred_revenue": { en: "Enable Deferred Revenue", th: "เปิดใช้งานรายได้รอตัดบัญชี" },
  "Item:no_of_months_expense": { en: "No of Months (Expense)", th: "จำนวนเดือน (ค่าใช้จ่าย)" },
  "Item:no_of_months": { en: "No of Months (Expense)", th: "จำนวนเดือน (ค่าใช้จ่าย)" },
  "Item:deferred_expense_account": { en: "Deferred Expense Account", th: "บัญชีค่าใช้จ่ายรอตัดบัญชี" },
  "Item:deferred_revenue_account": { en: "Deferred Revenue Account", th: "บัญชีรายได้รอตัดบัญชี" },
  "Item:grant_commission": { en: "Grant Commission", th: "ให้ค่าคอมมิชชั่น" },
  "Item:max_discount": { en: "Max Discount (%)", th: "ส่วนลดสูงสุด (%)" },
  "Item:max_discount_percent": { en: "Max Discount (%)", th: "ส่วนลดสูงสุด (%)" },
  
  // Sales fields
  "Item:sales_uom": { en: "Sales UOM", th: "หน่วยขาย" },
  "Item:sales_price_list": { en: "Sales Price List", th: "รายการราคาขาย" },
  "Item:customer": { en: "Customer", th: "ลูกค้า" },
  "Item:customer_name": { en: "Customer Name", th: "ชื่อลูกค้า" },
  "Item:customer_group": { en: "Customer Group", th: "กลุ่มลูกค้า" },
  "Item:customer_items": { en: "Customer Items", th: "สินค้าลูกค้า" },
  "Item:ref_code": { en: "Ref Code", th: "รหัสอ้างอิง" },
  "Item:selling_cost_center": { en: "Selling Cost Center", th: "ศูนย์ต้นทุนขาย" },
  "Item:default_selling_price_list": { en: "Default Selling Price List", th: "รายการราคาขายเริ่มต้น" },
  "Item:min_selling_price": { en: "Min Selling Price", th: "ราคาขายขั้นต่ำ" },
  "Item:max_selling_price": { en: "Max Selling Price", th: "ราคาขายสูงสุด" },
  "Item:allow_in_web_catalog": { en: "Allow in Web Catalog", th: "อนุญาตในแคตตาล็อกเว็บ" },
  "Item:web_item_name": { en: "Web Item Name", th: "ชื่อสินค้าในเว็บ" },
  "Item:published_in_website": { en: "Published in Website", th: "เผยแพร่ในเว็บไซต์" },
  "Item:route": { en: "Route", th: "เส้นทาง" },
  "Item:show_in_website": { en: "Show in Website", th: "แสดงในเว็บไซต์" },
  "Item:website_image": { en: "Website Image", th: "รูปภาพเว็บไซต์" },
  "Item:website_warehouse": { en: "Website Warehouse", th: "คลังสินค้าเว็บไซต์" },
  "Item:weightage": { en: "Weightage", th: "น้ำหนัก" },
  
  // Tax fields
  "Item:tax_category": { en: "Tax Category", th: "หมวดภาษี" },
  "Item:gst_hsn_code": { en: "GST HSN Code", th: "รหัส HSN สำหรับ GST" },
  "Item:hsn_code": { en: "HSN Code", th: "รหัส HSN" },
  "Item:tax_code": { en: "Tax Code", th: "รหัสภาษี" },
  "Item:supplier_tax_code": { en: "Supplier Tax Code", th: "รหัสภาษีผู้ขาย" },
  "Item:customer_tax_code": { en: "Customer Tax Code", th: "รหัสภาษีลูกค้า" },
  "Item:tax_classification": { en: "Tax Classification", th: "การจัดประเภทภาษี" },
  "Item:item_tax_template": { en: "Item Tax Template", th: "เทมเพลตภาษีสินค้า" },
  "Item:valid_from": { en: "Valid From", th: "ใช้ได้ตั้งแต่" },
  "Item:minimum_net_rate": { en: "Minimum Net Rate", th: "อัตราสุทธิขั้นต่ำ" },
  "Item:maximum_net_rate": { en: "Maximum Net Rate", th: "อัตราสุทธิสูงสุด" },
  
  // Manufacturing and BOM
  "Item:default_bom": { en: "Default BOM", th: "BOM เริ่มต้น" },
  "Item:default_item_manufacturer": { en: "Default Item Manufacturer", th: "ผู้ผลิตสินค้าเริ่มต้น" },
  "Item:default_manufacturer_part_no": { en: "Default Manufacturer Part No", th: "หมายเลขชิ้นส่วนผู้ผลิตเริ่มต้น" },
  
  // Additional batch/serial fields
  "Item:serial_no_series": { en: "Serial No Series", th: "ชุดหมายเลขซีเรียล" },
  "Item:has_variants": { en: "Has Variants", th: "มีตัวแปร" },
  "Item:variant_of": { en: "Variant Of", th: "ตัวแปรของ" },
  "Item:variant_based_on": { en: "Variant Based On", th: "ตัวแปรตาม" },
  
  // Stock settings
  "Item:maintain_stock": { en: "Maintain Stock", th: "ดูแลสต็อก" },
  "Item:over_delivery_receipt_allowance": { en: "Over Delivery Receipt Allowance", th: "อนุญาตการรับเกิน" },
  "Item:over_billing_allowance": { en: "Over Billing Allowance", th: "อนุญาตการเรียกเก็บเกิน" },
  "Item:stock_uom_rate": { en: "Stock UOM Rate", th: "อัตราหน่วยสต็อก" },
  
  // Add more Item fields as needed
};

